import { PCI_LIST_TYPES } from 'Common/enums';

export const checkIfPCIList = (listType: any) => PCI_LIST_TYPES.some((v) => v === listType);

export const getLinkedRulesCount = (
    linkedSandboxRules?: LinkedSandboxRules,
    linkedDeployedRules?: LinkedDeployedRules
) => {
    return (linkedSandboxRules || []).length + (linkedDeployedRules || []).length;
};

export const getStringListIds = (targetList: RuleLists) => {
    return targetList.listIds.map((id: number) => id.toString());
};

export const getNumericListIds = (value: string[]) => {
    return Object.values(value).map((id: string) => Number(id));
};
